<h2>Image generation</h2>

<!--Allow user to change the font size using input-->
<div class="row">
  <div class="col-5">
    <mat-form-field appearance="outline">
      <mat-label>Pad left</mat-label>
      <input
        matInput
        [(ngModel)]="padLeft"
        placeholder="Font size"
        type="number"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Pad top</mat-label>
      <input
        matInput
        [(ngModel)]="padTop"
        placeholder="Font size"
        type="number"
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Font size</mat-label>
      <input
        matInput
        [(ngModel)]="fontSize"
        placeholder="Font size"
        type="number"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <textarea
        matInput
        (blur)="drawText()"
        [(ngModel)]="quizContent"
        placeholder="Input"
        rows="10"
      ></textarea>
    </mat-form-field>
  </div>

  <div class="col-7">
    <div id="quiz-canvas-container">
      <canvas height="720" id="quiz-image-canvas" width="1280"></canvas>
    </div>
  </div>
</div>

<div class="row">
  <button (click)="generateImage()" mat-flat-button color="primary">Generate</button>
</div>
